import * as d3 from 'd3';
import { useState } from 'react';

// Sub-components
import NodeVisible from './NodeVisible';
import NodeInvisible from './NodeInvisible';
import Label from './Label';

const NodesLabels = ({ people, num_people, radius, radius_off_screen, highlighted_person, highlighted_trip, segment_gap, selected_person_change, set_focused_person, set_selected_person, animating}) => {

  const interpolateRainbowTruncated = (x) => d3.interpolateRainbow(1 - (1-x)*0.8);
  const colors = d3.quantize(interpolateRainbowTruncated, num_people);

  const [initial_animation_delays, _] = useState([...Array(num_people)].map(Math.random));

  // Create nodes & labels
  let visible_nodes = [];
  let invisible_nodes = [];
  let labels = [];
  for (let i in people) {
    i = parseInt(i);
    const person = people[i];
    // Node
    let person_is_noteworthy = (highlighted_person === person.person_index);
    for (let j = 0; j < person.person_trips.length; j++) {
      if (person.person_trips[j].trip_index === highlighted_trip) {
        person_is_noteworthy = true;
        break;
      }
    }

    const set_focused_this_person = () => {
      set_focused_person(person.person_index);
    }
    const set_selected_this_person = () => {
      set_selected_person(person.person_index);
    }
    const set_unhighlighted_person = () => {
      set_focused_person(null);
    }

    visible_nodes.push(<NodeVisible key={person.person_index}
                                    person={person}
                                    person_is_noteworthy={person_is_noteworthy}
                                    radius={radius}
                                    radius_off_screen={radius_off_screen}
                                    fill={colors[person.person_index]}
                                    animating={animating}
                                    selected_person_change={selected_person_change}
                                    initial_animation_delay={initial_animation_delays[i]}/>);
    invisible_nodes.push(<NodeInvisible key={person.person_index}
                                        person={person}
                                        radius={radius}
                                        segment_gap={segment_gap}
                                        selected_person_change={selected_person_change}
                                        set_focused_this_person={set_focused_this_person}
                                        set_unhighlighted_person={set_unhighlighted_person}
                                        set_selected_this_person={set_selected_this_person}/>);
    labels.push(<Label key={person.person_index}
                       person={person}
                       radius={radius}
                       radius_off_screen={radius_off_screen}
                       selected_person_change={selected_person_change}
                       initial_animation_delay={initial_animation_delays[i]}
                       set_focused_this_person={set_focused_this_person}
                       set_unhighlighted_person={set_unhighlighted_person}
                       set_selected_this_person={set_selected_this_person}/>);
  }

  return (<>
    <g id="invisible_nodes">
      {invisible_nodes}
    </g>
    <g id="visible_nodes">
      {visible_nodes}
    </g>
    <g id="labels">
      {labels}
    </g>
  </>);
};

export default NodesLabels;
